<template>
	<v-tooltip top>
		<v-btn
			dark
			flat
			icon
			slot="activator"
			class="my-0 mx-0"
			:disabled="disabled"
			:color="color"
			:style="`width:${width}px`"
			@click.prevent="clickIcon"
		>
			<template v-if="icon">
				<v-icon :color="color" :size="size" :style="isListAll">{{ icon }}</v-icon>
			</template>
			<template v-else>
				<img :src="img" alt="text">
			</template>
		</v-btn>
		<span>{{ text }}</span>
	</v-tooltip>
</template>

<script>

function clickIcon($e) {
	this.$emit('click-icon', $e);
}

function isListAll() {
	return this.icon === 'list_all' ? 'height:24px;width:24px' : '';
}

export default {
	name: 'app-tooltip-button',
	computed: {
		isListAll,
	},
	props: {
		color: {
			type: String,
			default: 'green',
		},
		icon: String,
		img: String,
		size: Number,
		text: {
			type: String,
			required: true,
		},
		width: {
			default: 20,
			type: Number,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		clickIcon,
	},
};
</script>
<style lang="scss" scoped>
	img {
		height: 100%;
		object-fit: contain;
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/components/shared/app-tooltip-button.vue